export default "__VITE_ASSET__BXGxVKPw__"